/**
 * @readonly
 * @enum {string}
 */

export const WorkStates = {
    UNKNOWN: 'UNKNOWN',
    FREETIME: 'FREETIME',
    PAUSE: 'PAUSE',
    AVAILABLE: 'AVAILABLE',
    WORKING: 'WORKING',
    DRIVING: 'DRIVING',
    OTHER_WORK: 'OTHER_WORK',
    SLEEPER_BERTH: 'SLEEPER_BERTH',
    ON_DUTY: 'ON_DUTY',
    OFF_DUTY: 'OFF_DUTY'
}

Object.freeze(WorkStates)
